import * as yup from 'yup';


const SHARED_USER_SCHEMA = {
    email: yup.string().trim().required('Required').email('Invalid email address'),
    name: yup.string().trim().required('Required'),
    role: yup.string().required('Required'),
};
const PASS_BASE = yup.string()
    .min(8, 'Must be at least 8 characters long')
    .matches(/[A-Z]+/, 'Must include at least 1 uppercase letter')
    .matches(/[a-z]+/, 'Must include at least 1 lowercase letter')
    .matches(/[0-9]+/, 'Must include at leat 1 numeric character');
export const CREATE_USER_VALIDATION_SCHEMA = yup.object().shape({
    ...SHARED_USER_SCHEMA,
    password: PASS_BASE.required('Required'),
    confirmPassword: yup.string().oneOf([yup.ref('password'), null], 'Confirm Password must match password').required('Required'),
});

export const UPDATE_USER_VALIDATION_SCHEMA = yup.object().shape({
    ...SHARED_USER_SCHEMA,
    password: PASS_BASE.notRequired(),
    confirmPassword: yup.string().when('password', ([val])=>{
        if (val) {
            return yup.string().oneOf([yup.ref('password'), null], 'Confirm Password must match password').required('Required');
        }
        return yup.string().notRequired();
    }),
});

export const USER_PROFILE_VALIDATION_SCHEMA = yup.object().shape({
    oldPassword: yup.string().trim().required('Required'),
    password: PASS_BASE.required('Required'),
    confirmPassword: yup.string().oneOf([yup.ref('password'), null], 'Confirm Password must match password').required('Required'),
});
